function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var fontScalePresets = {
  majorSecond: [1.802, 1.602, 1.424, 1.266, 1.125, 1],
  minorThird: [2.488, 2.074, 1.728, 1.44, 1.2, 1],
  majorThird: [3.052, 2.441, 1.953, 1.563, 1.25, 1],
  perfectFourth: [4.209, 3.157, 2.369, 1.777, 1.333, 1],
  augmentedFourth: [5.653, 3.998, 2.827, 1.999, 1.414, 1]
};

var getNumber = function getNumber(value) {
  if (typeof value === 'number') return value;
  return parseFloat(value);
};

var getFontUnit = function getFontUnit(size) {
  var match = size.match(/px|r?em$/);

  if (!match) {
    throw new Error('Unsupported font unit: Shevy only supports px, em, or rem.');
  }

  return match[0];
};

var toMax6 = function toMax6(arr) {
  if (arr.length > 6) return arr.slice(0, 6);
  return arr;
};

var getFontScale = function getFontScale(fontScale) {
  if (Array.isArray(fontScale)) {
    return toMax6(fontScale);
  }

  if (fontScalePresets[fontScale]) {
    return fontScalePresets[fontScale];
  }

  throw new Error("No Font Scale Preset Found for \"" + fontScale + "\", the presets available are: \"" + Object.keys(fontScalePresets) + "\"");
};

var defaultOptions = {
  baseFontSize: '16px',
  baseLineHeight: 1.5,
  fontScale: [3, 2.5, 2, 1.5, 1.25, 1],
  includeMarginBottom: true,
  proximity: null,
  precision: null
};
var UNDEFINED_STYLE = {
  fontSize: undefined,
  lineHeight: undefined,
  marginBottom: undefined
};
/**
 * Factory function that returns a Shevy object
 */

function createShevy(options) {
  if (options === void 0) {
    options = {};
  }

  var config = _extends({}, defaultOptions, options);

  var baseFontSize = config.baseFontSize,
      baseLineHeight = config.baseLineHeight,
      fontScale = config.fontScale,
      includeMarginBottom = config.includeMarginBottom,
      precision = config.precision,
      proximity = config.proximity;
  var scaleValues = getFontScale(fontScale);
  var fontUnit = getFontUnit(baseFontSize);

  function applyPrecision(num) {
    return precision ? Number(num.toFixed(precision)) : num;
  }

  function getSpacing(factor) {
    var value = getNumber(baseFontSize);
    var spacing = value * baseLineHeight * factor;
    return spacing;
  }

  function applyProximity(size) {
    if (proximity === null) return size;
    return size * proximity;
  }

  function applyUnit(size) {
    return "" + size + fontUnit;
  }

  function getBaseSpacing(factor) {
    return applyUnit(applyPrecision(applyProximity(getSpacing(factor))));
  }

  function getHeadingStyle(factor) {
    if (factor === undefined) return UNDEFINED_STYLE;
    return {
      fontSize: calculateHeadingFontSize(factor),
      lineHeight: calculateHeadingLineHeight(factor),
      marginBottom: includeMarginBottom ? calculateHeadingMarginBottom(factor) : undefined
    };
  }

  function calculateHeadingFontSize(factor) {
    var fontValue = factor * getNumber(baseFontSize);
    var fontSize = applyUnit(fontValue);
    return fontSize;
  }
  /**
   * Contains the algorithm for determining the line height for headings.
   *
   * Typically, a vertical rhythm would not allow for half-spacings, but
   * this algorithm makes use of them.
   *
   * Only allowing whole-spacings can result in rather large line heights
   * for headings that are _just_ greater than the base spacing.
   *
   * Example: a heading fontSize of 50px but a base spacing of 48px would
   * result in a line height of 1.92.
   *
   * I have found it more aesthetically pleasing to keep the line heights
   * tighter to the font size, and thus increment a half-spacing at a time.
   */


  function calculateHeadingLineHeight(factor) {
    var fontValue = factor * getNumber(baseFontSize);
    var spacing = getSpacing(1);

    if (fontValue <= spacing) {
      return applyPrecision(spacing / fontValue);
    }

    var multiplier = 1;

    do {
      multiplier += 0.5;
      spacing = getSpacing(multiplier);
    } while (spacing < fontValue);

    return applyPrecision(spacing / fontValue);
  }

  function calculateHeadingMarginBottom(factor) {
    var margin = applyProximity(getSpacing(1));

    if (fontUnit === 'em') {
      var fontSize = calculateHeadingFontSize(factor);
      var fontValue = getNumber(fontSize);
      margin = margin / fontValue;
    }

    return applyUnit(margin);
  }

  var body = {
    fontSize: baseFontSize,
    lineHeight: baseLineHeight
  };
  var content = {
    fontSize: baseFontSize,
    lineHeight: baseLineHeight,
    marginBottom: includeMarginBottom ? getBaseSpacing(1) : undefined
  };
  return {
    baseSpacing: function baseSpacing(factor) {
      if (factor === void 0) {
        factor = 1;
      }

      return getBaseSpacing(factor);
    },
    lineHeightSpacing: function lineHeightSpacing(factor) {
      if (factor === void 0) {
        factor = 1;
      }

      return applyUnit(applyPrecision(getSpacing(factor)));
    },
    body: body,
    content: content,
    h1: getHeadingStyle(scaleValues[0]),
    h2: getHeadingStyle(scaleValues[1]),
    h3: getHeadingStyle(scaleValues[2]),
    h4: getHeadingStyle(scaleValues[3]),
    h5: getHeadingStyle(scaleValues[4]),
    h6: getHeadingStyle(scaleValues[5])
  };
}

export default createShevy;